import { takeLatest, put } from 'redux-saga/effects';
import { fetchAppMessages, appNotify, updateAppMessages, deleteAppMessage, 
  createAppMessage, updateAppMessage } from 'store/actions';
import { getWithToken, deleteWithToken, postWithToken, patchWithToken } from 'api/network';

export function* getAppMessageSaga() {
  yield takeLatest(fetchAppMessages, function* () {
    try {
      const res = yield getWithToken('/api/admin/appMessages');
      const data = yield res?.json();

      yield put(updateAppMessages(data));
    } catch (error) {
      console.log(error.message);
      yield put(appNotify(`Failed to fetch app messages: ${error.message}`, 'error'));
    }
  });
}

export function* deleteAppMessageSaga() {
  yield takeLatest(deleteAppMessage, function* ({ payload: id }) {
    try {
      console.log(`deleteAppMessageSaga triggered with id = ${id}`);
      yield deleteWithToken(`/api/admin/appMessages/${id}`);
    } catch (error) {
      console.log(error.message);
      yield put(appNotify(`Failed to delete app messages: ${error.message}`, 'error'));
    }
  });
}

export function* createAppMessageSaga() {
  yield takeLatest(createAppMessage, function* ({ payload }) {
    try {
      console.log(`createAppMessageSaga triggered with request = ${payload}`);
      yield postWithToken(`/api/admin/appMessages`, payload);
    } catch (error) {
      console.log(error.message);
      yield put(appNotify(`Failed to create app messages: ${error.message}`, 'error'));
    }
  });
}
  
export function* updateAppMessageSaga() {
  yield takeLatest(updateAppMessage, function* ({ payload }) {
    try {
      const { id, isVisible, isMain } = payload;
      console.log(`updateAppMessageSaga triggered with id = ${id} isVisible = ${isVisible} isMain = ${isMain}`);
      yield patchWithToken(`/api/admin/appMessages/${id}?isMain=${isMain}`);
    } catch (error) {
      console.log(error.message);
      yield put(appNotify(`Failed to update app messages: ${error.message}`, 'error'));
    }
  });
}